import { useQuery, UseQueryOptions } from "react-query";
import { getForm } from "../services/typeform.service";

export function useGetForm<T>(formId: string,
    options?: UseQueryOptions<any, unknown, T>
) {
    return useQuery({
        queryKey: ["typeform", formId],
        queryFn: () => {
            return getForm(formId).then((r) => r.data);
        },
        retry: 1,
        refetchOnWindowFocus: false,
        staleTime: 15 * 60 * 1000,
        ...options
    });
}